import React, {useState} from 'react';

function NewlineText({text}) {
    return text?.split('\n').map((str, index) => <div key={index}>{str}</div>);
}

const OpenHuisBanner = ({bannerText}) => {

    const [shown, setShown] = useState(true);

    if (!shown) {
        return '';
    }

    return (
        <React.Fragment>
            <div className="OpenHuisBanner_block d-none d-lg-inline-flex">
                <div className="OpenHuisBanner_text">
                    <i className="fa fa-times cursor-pointer" style={{fontSize: '18px', position: 'absolute',top: '8px', right: '8px', opacity: '0.4'}} onClick={() => setShown(false)}></i>
                    <NewlineText text={bannerText} />
                </div>
            </div>
            <div className="OpenHuisBanner_block-mobile d-inline-flex d-lg-none fixed-bottom">
                <div className="OpenHuisBanner_text-mobile">
                    <i className="fa fa-times cursor-pointer" style={{fontSize: '18px', position: 'absolute',top: '8px', right: '8px', opacity: '0.4'}} onClick={() => setShown(false)}></i>
                    <NewlineText text={bannerText} />
                </div>
            </div>
        </React.Fragment>
    );
}

export { OpenHuisBanner };
